// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"539":"541cfce9","656":"d7c07210","779":"d34762c5","795":"98103ab4","929":"1c8fdb33","968":"49263f47"}[chunkId] + ".chunk.js";
};